export * from './lib/if-is-server.directive';
export * from './lib/if-is-browser.directive';
export * from './lib/ngx-ssr-platform.module';
export * from './lib/tokens';
